import { useEffect, useState } from "react";
import { LifeBuoy, Plus, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { ThreadView, SUPPORT_STATUS } from "@/components/support/ThreadView";
import { NewThreadForm } from "@/components/support/NewThreadForm";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const TicketCenter = () => {
  const [items, setItems] = useState([]);
  const [view, setView] = useState("list");
  const load = () => api.get("/support/threads", { params: { kind: "TICKET" } }).then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (view === "new") return <><Button variant="ghost" size="sm" onClick={() => setView("list")}><ArrowLeft className="w-4 h-4 mr-1" />Taleplerim</Button><NewThreadForm kind="TICKET" prefix="ticket" onCreated={(t) => { load(); setView(t.id); }} /></>;
  if (view !== "list") return (
    <div className="flex flex-col h-[420px] border rounded-lg overflow-hidden">
      <div className="p-2 border-b flex items-center gap-2"><Button variant="ghost" size="sm" onClick={() => { setView("list"); load(); }}><ArrowLeft className="w-4 h-4" /></Button><span className="text-sm font-medium truncate">{items.find((x) => x.id === view)?.subject}</span></div>
      <div className="flex-1 min-h-0"><ThreadView threadId={view} /></div>
    </div>
  );
  return (
    <div className="space-y-2" data-testid="ticket-list">
      <Button data-testid="ticket-new-btn" className="w-full bg-slate-900" onClick={() => setView("new")}><Plus className="w-4 h-4 mr-1" />Yeni destek talebi</Button>
      {items.length === 0 ? <div className="text-sm text-slate-500 text-center py-6">Henüz destek talebiniz yok</div> : items.map((t) => (
        <button key={t.id} data-testid={`ticket-row-${t.ticket_no}`} onClick={() => setView(t.id)} className="w-full text-left rounded-lg border p-3 hover:bg-slate-50">
          <div className="flex items-center gap-2"><span className="font-mono text-xs text-slate-500">{t.ticket_no}</span><span className="font-medium text-sm truncate flex-1">{t.subject}</span>
            <Badge variant="outline" className={t.status === "ANSWERED" ? "border-emerald-400 text-emerald-700" : ""}>{SUPPORT_STATUS[t.status]}</Badge>{t.unread_user && <span className="w-2 h-2 rounded-full bg-red-500" />}</div>
          <div className="text-xs text-slate-500 truncate mt-0.5">{t.last_message}</div>
        </button>
      ))}
    </div>
  );
};

export const TicketButton = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button data-testid="ticket-open-btn" variant="outline" size="sm" onClick={() => setOpen(true)} className="bg-white/70" aria-label="Destek Talebi"><LifeBuoy className="w-4 h-4 sm:mr-1.5" /><span className="hidden sm:inline">Destek Talebi</span></Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="ticket-dialog">
          <DialogHeader><DialogTitle>Destek Talepleri</DialogTitle></DialogHeader>
          {open && <TicketCenter />}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default function SupportPage() {
  return (
    <div className="max-w-2xl space-y-4" data-testid="support-page">
      <h1 className="text-4xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>Destek Talepleri</h1>
      <TicketCenter />
    </div>
  );
}
